// third party imports
import React, { useState } from 'react';

// internal rebet imports
import styles from './stylesUserActions.module.css';
import createPrivateAdminPanelInstance from '../../../../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../../../../api/ApiRoutes';

// component imports
import RebetLoader from '../../../CommonComponents/RebetLoader/RebetLoader';

// asset imports

const UserActions = ({
  userData,
  onManageMoneyPressed,
  onSuspendUserPressed,
  onToggleACHPressed,
  onEditUserDataPressed,
  onEditPersonalLimitsPressed,
  onEditFreeBetPressed,
  onEditProfitBoostPressed,
  onEditCreditCardsPressed,
  onEditAvailablePromotionsPressed,
  onPaymentInstrumentsPressed,
  onDeleteUserPressed,
  onAppStoreWrittenReviewPressed,
  onGamePassTogglePressed,
  onGlobalChatTogglePressed,
}) => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  // state variables
  const [emailVerificationSending, setEmailVerificationSending] =
    useState(false);

  // use effects

  // api functions
  const sendEmailVerification = async () => {
    setEmailVerificationSending(true);

    const params = {
      user_id: userData?.user_id,
      email: userData?.email,
    };

    try {
      await PrivateAdminPanelInstance?.post(
        API_ROUTES?.SEND_EMAIL_VERIFICATION,
        params
      );

      setEmailVerificationSending(false);
    } catch (error) {
      console.log('error sending email verification code', error?.response);
      setEmailVerificationSending(false);
    }
  };

  // helper functions
  const handleManageMoneyPressed = () => {
    onManageMoneyPressed();
  };

  const handleSuspendUserPressed = () => {
    onSuspendUserPressed();
  };

  const handleToggleACHPressed = () => {
    onToggleACHPressed();
  };

  const handleEditUserDataPressed = () => {
    onEditUserDataPressed();
  };

  const handleEditPersonalLimitsPressed = () => {
    onEditPersonalLimitsPressed();
  };

  const handleFreebetPressed = () => {
    onEditFreeBetPressed();
  };

  const handleProfitBoostPressed = () => {
    onEditProfitBoostPressed();
  };

  const handleCreditCardsPressed = () => {
    onEditCreditCardsPressed();
  };

  const handleAvailablePromotionsPressed = () => {
    onEditAvailablePromotionsPressed();
  };

  const handlePaymentInstrumentsPressed = () => {
    onPaymentInstrumentsPressed();
  };

  const handleSendEmailVerification = () => {
    sendEmailVerification();
  };

  const handleDeleteUserPrsssed = () => {
    onDeleteUserPressed();
  };

  const handleAppStoreWrittenReviewPressed = () => {
    onAppStoreWrittenReviewPressed();
  };

  const handleGamePassTogglePressed = () => {
    onGamePassTogglePressed();
  };

  const handleGlobalChatTogglePressed = () => {
    onGlobalChatTogglePressed();
  };

  return (
    <div className={styles.userActions}>
      <p className={styles.headerText}>Actions</p>

      <div className={styles.dividerLine} />

      <div className={styles.buttonsRow}>
        <button
          className={styles.actionButton}
          onClick={handleSuspendUserPressed}
        >
          Suspend / Unsuspend
        </button>
        <button
          className={styles.actionButton}
          onClick={handleManageMoneyPressed}
        >
          Edit Wallet
        </button>
      </div>

      <div className={styles.buttonsRow}>
        <button
          className={styles.actionButton}
          onClick={handlePaymentInstrumentsPressed}
        >
          Payment Instruments
        </button>
        <button
          className={styles.actionButton}
          onClick={handleToggleACHPressed}
        >
          Toggle ACH
        </button>
      </div>

      <div className={styles.buttonsRow}>
        <button
          className={styles.actionButton}
          onClick={handleEditUserDataPressed}
        >
          Edit User
        </button>
        <button
          className={styles.actionButton}
          onClick={handleSendEmailVerification}
        >
          {emailVerificationSending ? (
            <RebetLoader height={'50px'} width={'50px'} />
          ) : (
            'Send Verification Email'
          )}
        </button>
      </div>

      <div className={styles.buttonsRow}>
        <button
          className={styles.actionButton}
          onClick={handleEditPersonalLimitsPressed}
        >
          Personal Limits
        </button>
        <button className={styles.actionButton} onClick={handleFreebetPressed}>
          Free Bet
        </button>
      </div>

      <div className={styles.buttonsRow}>
        <button
          className={styles.actionButton}
          onClick={handleProfitBoostPressed}
        >
          Profit Boost
        </button>
        <button
          className={styles.actionButton}
          onClick={handleAvailablePromotionsPressed}
        >
          Available Promotions
        </button>
      </div>

      <div className={styles.buttonsRow}>
        <button
          className={styles.actionButton}
          onClick={handleCreditCardsPressed}
        >
          Credit Cards
        </button>
        <button
          className={styles.actionButton}
          onClick={handleAppStoreWrittenReviewPressed}
        >
          App Store Written Review
        </button>
      </div>

      <div className={styles.buttonsRow}>
        <button
          className={styles.actionButton}
          onClick={handleGamePassTogglePressed}
        >
          Game Pass Toggle
        </button>
        <button
          className={styles.actionButton}
          onClick={handleGlobalChatTogglePressed}
        >
          Global Chat Toggle
        </button>
      </div>

      <div className={styles.deleteUserContainer}>
        <button
          className={styles.deleteUserButton}
          onClick={handleDeleteUserPrsssed}
        >
          Delete User
        </button>
      </div>
    </div>
  );
};

export default UserActions;
